import { MouseEvent } from "react";
import { Button } from "primereact/button";

interface IButtonProps {
  id?: string;
  testId?: string;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  icon?: string;
  classNames?: string;
  tooltip?: string;
  text?: boolean;
  type?: "button" | "submit" | "reset";
  severity?: "secondary" | "success" | "info" | "warning" | "danger" | "help" | undefined;
  iconPos?: "left" | "right" | undefined;
  size?: "small" | "large" | undefined;
  tooltipOptions?: {
    position?: "top" | "bottom" | "left" | "right";
    event?: "hover" | "focus";
  };
}

const REIButton: React.FC<IButtonProps> = ({
  id,
  testId,
  label,
  disabled,
  loading,
  onClick,
  icon,
  classNames,
  tooltip,
  text,
  type,
  severity,
  iconPos = "left",
  size = undefined,
  tooltipOptions,
}) => {
  return (
    <Button
      id={id}
      data-testid={testId ?? id}
      disabled={disabled}
      loading={loading}
      label={label}
      onClick={onClick}
      icon={icon}
      text={text}
      type={type}
      tooltip={tooltip}
      tooltipOptions={tooltipOptions}
      severity={severity}
      iconPos={iconPos}
      size={size}
      className={classNames}
    />
  );
};

export default REIButton;
